module.exports = __webpack_public_path__ + "img/noremind@2x.6afacf0a.png";